<template>
  <div :lang="$i18n.locale">
    <!-- 更新FBA信息 -->
    <el-dialog
    :title="$t('storageCharge.exportStorageFee')"
    :close-on-click-modal="false"
    :visible.sync="popup"
    width="540px"
    :before-close="handleDialogClose"
		v-loading="loading"
    >
      <el-form label-width="120px" :model="form" ref="form" :rules="rules" :inline="true">
      	<el-form-item :label="$t('commonInfo.packageNo')" prop="packageNo">
      		<el-input v-model.trim="form.packageNo" type="textarea" clearable
      			:placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.packageNo')" style="width: 350px;"></el-input>
      	</el-form-item>
      	<el-form-item :label="$t('storageCharge.chargeDate')" prop="chargeMonth">
      		<el-date-picker v-model="form.chargeMonth" type="month" value-format="yyyy-MM-dd"
					:placeholder="$t('tipsInfo.selectPlaceholder') + $t('storageCharge.chargeDate')"
					 style="margin-right: 10px;width:350px;"
      			></el-date-picker>
      	</el-form-item>
      </el-form>
      <el-footer style="text-align: right;margin-top: 20px;">
				<el-button @click="handleDialogClose" :disabled="submitLoading">{{$t('commonInfo.dialogBtnClose')}}</el-button>
      	<el-button type="primary" :loading="submitLoading" :disabled="submitLoading" @click="handleSubmit"
      		>
      		{{submitLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}
      	</el-button>
      </el-footer>
    </el-dialog>
  </div>

</template>

<script>
	import {returnMonthLastDate} from "@/utils/index";
	import {downloadStream} from "@/utils/downloadFileStream";
  export default {
    name: 'ExportCartonStorageFee',
		components:{
		},
    // 获取父组件信息
    props: {
      isShow:{
      	type:Boolean,
      	default:function(){
      		return false;
      	}
      },
    },
    watch:{
      //监听按钮名称和提示文字
      'isShow':{
      	handler(newValue){
          if(newValue){
            this.popup = newValue;
            
          }
      	},
      	immediate: true,
      },
    },
    data() {
      return {
        popup:false,
        loading:false,
				submitLoading:false,
        form:{
					packageNo:'',
					chargeDateList:[],
					productType:2,
					chargeMonth:'',
				},
				choiceDate:'',
				pickerOptions:{// 限制选择当前及之前的日期，且所选范围不能超出一个月
				  // 设置不能选择的日期
					onPick:({maxDate,minDate}) => {
						this.choiceDate = minDate.getTime();
						if(maxDate){
							this.choiceDate = '';
						}
					},
					disabledDate:(time) => {
						let choiceTime = new Date(this.choiceDate).getTime();
						const minTime = new Date(choiceTime).setMonth(new Date(choiceTime).getMonth() - 1)
						const maxTime = new Date(choiceTime).setMonth(new Date(choiceTime).getMonth() + 1)
						const min = minTime;
						const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24*3600*1000 - 1;
						const max = newDate < maxTime ? newDate:maxTime
						// 已选中一个日期，则返回该日期前后一个月可选
						if(this.choiceDate){
							return time.getTime() < min || time.getTime() > max
						}
						// 未选中日期，则当前日期及以前都可选
						return time.getTime() > newDate;
					}
					
				}
      }
    },
		//监听属性 类似于data概念
		computed: {
			rules() { // 表单验证需要在计算属性定义，才能实现实时更新国际化提示信息
				return {
					chargeMonth: [{
						required: true,
						message: this.$t('tipsInfo.selectPlaceholder') + this.$t('storageCharge.chargeDate'),
						trigger: 'blur'
					}],
				}
			},
		},

    //方法集合
    methods: {
      // 关闭窗口
      handleDialogClose(){
        this.popup = false;
				this.form ={
					packageNo:'',
					chargeDateList:[],
					chargeMonth:'',
				}
        this.$parent.exportCartonStorageFeePopup = false;
      },
			//提交修改信息
			handleSubmit() {
				let that = this;
				this.$refs['form'].validate((vaild) => { //表单验证
					if (vaild) {
						that.form.chargeDateList.length = 0;
						that.form.chargeDateList.push(that.form.chargeMonth)
						let dateList = that.form.chargeMonth.split('-');
						that.form.chargeDateList.push(returnMonthLastDate(dateList[0],dateList[1],'2'));
						that.submitLoading = true;
						that.$http.post("/toborder/wh/storageCharge/exportCartonBySearch",this.form,{
				      responseType:'blob',
			      }).then(res => {
							if (res.code != 500) {
								that.$message.success(this.$t('tipsInfo.success'))
								that.submitLoading = false;
								downloadStream(res,'xlsx','Carton '+this.$t('storageCharge.storageFee'))
								that.handleDialogClose();
							}else{
								that.$message.error(res.msg);
								that.submitLoading = false;
							}
							
						}).catch(err => {
							that.submitLoading = false;
							that.$message.error(err.msg);
						})
					}
				})
			},
    },
    created() {
    },

  }
</script>

<style scoped>
	
</style>
